import React from 'react';
import { Eye, EyeOff, GripVertical } from 'lucide-react';

interface Props {
  hidden: boolean;
  dragging: boolean;
  handleRef: (element: HTMLElement | null) => void;
  /** dnd-kit's `attributes` + `listeners` for the activator. */
  handleProps: React.HTMLAttributes<HTMLButtonElement>;
  onToggleHidden: () => void;
}

/** The drag handle and the show/hide toggle of one Handwerker, stacked at the card's right edge. */
export const CalendarOrderControls = ({
  hidden,
  dragging,
  handleRef,
  handleProps,
  onToggleHidden,
}: Props) => (
  <div className="flex shrink-0 flex-col items-center gap-1">
    <button
      type="button"
      ref={handleRef}
      aria-label="Reihenfolge ändern"
      title="Ziehen zum Sortieren"
      className={`flex h-7 w-7 touch-none items-center justify-center rounded text-slate-500 hover:bg-slate-100 ${
        dragging ? 'cursor-grabbing' : 'cursor-grab'
      }`}
      {...handleProps}
    >
      <GripVertical size={18} aria-hidden />
    </button>
    <button
      type="button"
      aria-label={hidden ? 'Einblenden' : 'Ausblenden'}
      title={hidden ? 'Einblenden' : 'Ausblenden'}
      aria-pressed={hidden}
      onClick={onToggleHidden}
      className="flex h-7 w-7 items-center justify-center rounded text-slate-500 hover:bg-slate-100"
    >
      {hidden ? <EyeOff size={18} aria-hidden /> : <Eye size={18} aria-hidden />}
    </button>
  </div>
);
